import { getBillablePlanByName, getLegacyPlanByName, } from "@workspace/db/constants/pricing";
export function isBillingPlanType(value) {
    return (value === "starter" ||
        value === "pro" ||
        value === "max" ||
        value === "starter_v2" ||
        value === "pro_v2" ||
        value === "max_v2" ||
        value === "enterprise");
}
export function resolveDefaultBillingPlanType(value) {
    return isBillingPlanType(value) ? value : "pro";
}
export function resolveRuntimePlanEntitlements(planType) {
    if (planType === "enterprise") {
        return {
            planType,
            usersLimit: null,
            locationsLimit: null,
            integrationsLimit: null,
            cuitsLimit: null,
            isCustom: true,
        };
    }
    const plan = getBillablePlanByName(planType);
    const isNewCatalog = planType === "starter_v2" || planType === "pro_v2" || planType === "max_v2";
    return {
        planType,
        usersLimit: plan.users,
        locationsLimit: plan.locations,
        integrationsLimit: plan.integrations,
        cuitsLimit: isNewCatalog ? 1 : null,
        isCustom: false,
    };
}
export function resolveLegacyInvoicesLimit(planType) {
    if (planType === "starter" || planType === "pro" || planType === "max") {
        return getLegacyPlanByName(planType).invoices;
    }
    return null;
}
